<template>

    <b-form @submit.prevent="" autocomplete="off">

        <b-row>

            <b-col md="6">

                <b-form-group class="w-100">
                    <label for="name"><strong>Nombre *</strong></label>
                    <b-form-input
                        required
                        id="name"
                        v-model="associatedProjectItem.name">
                    </b-form-input>
                </b-form-group>

            </b-col>

            <b-col>

                <label><strong>Fecha de inicio</strong></label>
                <v-date-picker
                    v-model='associatedProjectItem.startDate'
                    class="p-0 form-control date-picker-w-100 date-picker-custom-border"
                    popoverDirection="bottom"
                    required>
                </v-date-picker>

            </b-col>

            <b-col>

                <label><strong>Fecha de finalización</strong></label>
                <v-date-picker
                    v-model='associatedProjectItem.endDate'
                    :min-date='associatedProjectItem.startDate'
                    class="p-0 form-control date-picker-w-100 date-picker-custom-border"
                    popoverDirection="bottom"
                    required>
                </v-date-picker>

            </b-col>

        </b-row>

        <b-row>

            <b-col>

                <b-form-group class="w-100">
                    <label for="description"><strong>Descripción</strong></label>
                    <b-form-textarea
                        id="description"
                        maxlength="1024"
                        rows="3"
                        v-model="associatedProjectItem.description">
                    </b-form-textarea>
                </b-form-group>

            </b-col>

        </b-row>

        <b-row v-if="associatedProjectItem.uuid">

            <b-col md="1" class="pr-0">
                <strong class="pt-1">Activo</strong>
            </b-col>

            <b-col md="1" class="p-0 pr-3">
                <label class="switch switch-pill switch-label switch-success">
                    <input type="checkbox" class="switch-input float-right" v-model="associatedProjectItem.active">
                    <span class="switch-slider" data-checked="Si" data-unchecked="No"></span>
                </label>
            </b-col>

            <b-col>

                <div>

                    <p v-if="associatedProjectItem.createdBy" class="text-right m-0">
                        Creado por &nbsp;<strong>{{associatedProjectItem.createdBy}}</strong>&nbsp; el día &nbsp;<strong>{{associatedProjectItem.createdAt | dateFormat('DD/MM/YYYY')}}</strong>
                    </p>

                    <p v-if="associatedProjectItem.updatedBy" class="text-right m-0 mb-2">
                        Actualizado por &nbsp;<strong>{{associatedProjectItem.updatedBy}}</strong>&nbsp; el día &nbsp;<strong>{{associatedProjectItem.updatedAt | dateFormat('DD/MM/YYYY')}}</strong>
                    </p>

                </div>

            </b-col>

        </b-row>

        <b-row class="mt-2">
            <div class="w-100 d-flex justify-content-between align-items-center m-0 px-3">
                <div>
                    <button
                        type="button"
                        class="btn btn-brand btn-danger btn-lg"
                        v-if="renderDeleteButton"
                        @click="deleteAssociatedProject">
                        Eliminar
                    </button>
                </div>
                <div>
                    <button
                        @click="submitAssociatedProject"
                        class="btn btn-brand btn-primary btn-lg"
                        v-if="renderSaveButton">
                        Guardar
                    </button>
                </div>
            </div>
        </b-row>

    </b-form>
</template>

<script>

    import { setupCalendar, DatePicker } from 'v-calendar';
    import 'v-calendar/lib/v-calendar.min.css';

    setupCalendar({
        firstDayOfWeek: 2 // Monday
    });

    export default {
        name: "AssociatedProjectForm",
        components: {
            'v-date-picker': DatePicker,
        },
        props: [
            'associatedProject',
            'renderDeleteButton',
            'renderSaveButton'
        ],
        data: function () {
            return {
                associatedProjectItem: {
                    uuid: null,
                    name: null,
                    description: null,
                    startDate: null,
                    endDate: null,
                    createdBy: null,
                    createdAt: null,
                    updatedBy: null,
                    updatedAt: null,
                    active: null
                },
            };
        },

        mounted() {
            this.loadAssociatedProjectItem();
        },

        methods: {

            loadAssociatedProjectItem() {
                if (this.associatedProject) {
                    this.associatedProjectItem = {
                        uuid: this.associatedProject.uuid,
                        name: this.associatedProject.name,
                        description: this.associatedProject.description,
                        startDate: this.associatedProject.startDate,
                        endDate: this.associatedProject.endDate,
                        createdBy: this.associatedProject.createdBy.name,
                        createdAt: this.associatedProject.createdAt,
                        updatedBy: this.associatedProject.updatedBy.name,
                        updatedAt: this.associatedProject.updatedAt,
                        active: this.associatedProject.active
                    };
                }
            },

            submitAssociatedProject() {
                this.$emit('save-associated-project', this.associatedProjectItem);
            },

            deleteAssociatedProject() {
                this.$emit('delete-associated-project');
            }
        }
    }

</script>

<style>
    .switch-success .switch-input:checked + .switch-slider {
        background-color: #025542;
        border-color: #025542;
    }
    .switch-success .switch-input:checked + .switch-slider::before {
        border-color: #025542;
    }
</style>